export const QUEUE_AHEAD_EXTRA_SECONDS = 30

/** @param {Record<string, unknown> | null | undefined} data */
export function parseTaskQueue(data) {
  if (!data || typeof data !== 'object') {
    return { queueAhead: null, queueTotal: null }
  }

  const aheadRaw = data.queue_ahead ?? data.queueAhead
  const totalRaw = data.queue_total ?? data.queueTotal
  const ahead = Number(aheadRaw)
  const total = Number(totalRaw)

  return {
    queueAhead: aheadRaw != null && Number.isFinite(ahead) && ahead >= 0 ? ahead : null,
    queueTotal: totalRaw != null && Number.isFinite(total) && total >= 0 ? total : null,
  }
}

export function hasTaskQueue(queue) {
  return queue?.queueAhead != null || queue?.queueTotal != null
}

/** @param {number | string | null | undefined} queueAhead */
export function queueExtraSeconds(queueAhead) {
  const ahead = Number(queueAhead)
  if (!Number.isFinite(ahead) || ahead <= 0) return 0
  return ahead * QUEUE_AHEAD_EXTRA_SECONDS
}

/**
 * Display `queue_ahead / queue_total`. Hidden when not queued (`queue_ahead === 0`).
 * @param {number | string | null | undefined} queueAhead
 * @param {number | string | null | undefined} queueTotal
 */
export function queuePosition(queueAhead, queueTotal) {
  const ahead = Number(queueAhead)
  const total = Number(queueTotal)
  if (!Number.isFinite(ahead) || ahead <= 0) return null
  if (!Number.isFinite(total) || total <= 0) return null
  return {
    position: ahead,
    total,
  }
}

export function resolveTaskQueue(primary, fallback) {
  const a = parseTaskQueue(primary)
  const b = parseTaskQueue(fallback)
  return {
    queueAhead: a.queueAhead ?? b.queueAhead,
    queueTotal: a.queueTotal ?? b.queueTotal,
  }
}

export function withTaskQueue(item, data) {
  const queue = parseTaskQueue(data)
  if (!hasTaskQueue(queue)) return item
  return {
    ...item,
    queue_ahead: queue.queueAhead,
    queue_total: queue.queueTotal,
  }
}

export function patchActiveGenerationQueue(patchActiveGeneration, data) {
  const queue = parseTaskQueue(data)
  if (!hasTaskQueue(queue) || typeof patchActiveGeneration !== 'function') return
  patchActiveGeneration(queue)
}

export function taskQueueLabel(t, data, fallback) {
  const queue = parseTaskQueue(data)
  const pos = queuePosition(queue.queueAhead, queue.queueTotal)
  if (!pos) return fallback
  return t('playground.taskQueue.position', pos)
}
